import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { FC, useMemo } from 'react'
import { Colors } from 'src/components/theme'

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

type DescriptionItemProps = {
  label: string
  value?: string | number | JSX.Element | null
  bold?: boolean
}

export const DescriptionItem: FC<DescriptionItemProps> = ({ label, value, bold = false }) => {
  const val = useMemo(() => {
    if (value === undefined || value === null) {
      return '--'
    }
    if (typeof value === 'number' || typeof value === 'string') {
      return (
        <Typography color={Colors.neutral700} fontSize={16} fontWeight={bold ? 700 : 400}>
          {value}
        </Typography>
      )
    }
    return value
  }, [value])

  return (
    <Container>
      <Typography color={Colors.neutral400} fontSize={14}>
        {label}
      </Typography>
      {val}
    </Container>
  )
}
